export default "/build/client/static/fonts/SoderbergSans-Regular.woff";